const fetchImagesFromFolder = (FOLDER, COUNT, PREFIX, SUFFIX, FILE_TYPE) => {
    let images = [];
    for(let i = 1; i <= COUNT; i++) {
        let current_image;
        if(SUFFIX) {
            current_image = '/images/' + FOLDER + PREFIX + i + SUFFIX + '.' + FILE_TYPE;
        } else {
            current_image = '/images/' + FOLDER + PREFIX + i + '.' + FILE_TYPE;
        }
        images.push(current_image);
    }
    return images;
}

export default fetchImagesFromFolder;